

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { OfferSummary } from '../../models/ProductDetails';

@Component
export default class ProductOffers extends Vue {
  @Prop() private offerSummary!: OfferSummary;

  get hasNewOffers() {
    return this.offerSummary.totalNewOffers > 0;
  }
  get hasUsedOffers() {
    return this.offerSummary.totalUsedOffers > 0;
  }
  get hasMultipleNewOffers() {
    return this.offerSummary.totalNewOffers > 1;
  }
  get hasMultipleUsedOffers() {
    return this.offerSummary.totalUsedOffers > 1;
  }
}
